import { Search } from "lucide-react";

import { Input } from "../../ui/input";

type SpotlightSearchProps = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
};

export const SpotlightSearch = ({
  value = "",
  onChange,
  placeholder = "Type Case Number, Claim Reference Number or Examinee Name here..",
}: SpotlightSearchProps) => {
  return (
    <Input
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      leftIcon={<Search className="size-4 text-foreground-muted" />}
      className="h-10 min-h-10 rounded-lg border-border bg-background-white shadow-none"
    />
  );
};
